<template>
  <div class="home-content-page-v" v-loading="loading">
    <div style="margin-bottom: 1rem;">
      <el-select v-model="selectGas" filterable placeholder="请输入关键词">
        <el-option v-for="item in gasList" :key="item['油站代码']" :label="item['加油站名称']" :value="item">
        </el-option>
      </el-select>
    </div>
    <content-title :title="selectGas['加油站名称']" :actions="titleAction" @clickMenu="clickTitleMenu"></content-title>
    <div class="gas-info">
      <div class="info-one">
        {{selectGas['单位名称']}}    -    {{selectGas['区域']}}
      </div>
      <div class="info-one">
        <span>通行证限制:</span>
        <div class="info-one">
          {{getTextTXZ(selectGas['通行证']) || '无'}}
        </div>
        <!-- <el-select v-model="pass_key" size="mini" style="width:7rem" placeholder="无限制">
          <el-option v-for="item in PASS_LIST" :key="item.key" :label="item.label" :value="item.key">
          </el-option>
        </el-select> -->
      </div>
      <div class="info-one">
        <span>车轴限制:</span>
        <el-select v-model="axle_key" size="mini" style="width:7rem" placeholder="无限制">
          <el-option v-for="item in AXLE_LIST" :key="item.key" :label="item.label" :value="item.key">
          </el-option>
        </el-select>
      </div>
      <div class="info-one" style="width: 66%;">
        <span style="min-width: 8rem;">指定配送车辆:</span>
        <div class="car-list">
          <strong style="color: #999;" v-if="!xzCarList || xzCarList.length === 0">没有配送车辆限制</strong>
          <span v-for="data in xzCarList" v-else>{{data['车牌号']}}<i class="icon-105 iconfont" @click="delXzCar(data)"></i></span>
        </div>
      </div>
      <div class="info-one">
        <span>添加车辆:</span>
        <el-select v-model="selectCar" size="mini" style="width:7rem" filterable placeholder="请输入关键词">
          <el-option v-for="(item, index) in carList" :key="item['车牌号'] + index" :label="item['车牌号']" :value="item">
          </el-option>
        </el-select>
      </div>
    </div>
    <content-title title="油品油罐" :actions="titleAction2" @clickMenu="clickTitleMenuG"></content-title>
    <div class="output-content" v-loading="loadingG">
      <mii-base-table :datas="oilGGList" :table_actions="table_actions" :table_style="2" :ths="ths" @clickTdBtn="clickTdBtn"></mii-base-table>
    </div>
    <el-dialog :title="isNew ? '新增加油站' : '修改加油站'" :visible.sync="showAdd">
      <div class="case-form">
        <div class="one-input" v-if="isNew">
          <span>油站代码</span>
          <el-input v-model="gasMap['油站代码']" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>加油站名称</span>
          <el-input v-model="gasMap['加油站名称']" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>区域</span>
          <el-input v-model="gasMap['区域']" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>单位名称</span>
          <el-input v-model="gasMap['单位名称']" size="small" placeholder="请输入"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false">取 消</el-button>
        <el-button type="primary" @click="saveGas">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="isNewG ? '新增油罐' : '修改油罐'" :visible.sync="showAddG">
      <div class="case-form">
        <div class="one-input">
          <span>油站代码</span>
          <el-input v-model="gasGMap['油站代码']" :disabled="true" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>罐号</span>
          <el-input v-model="gasGMap['罐号']" :disabled="!isNewG" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>油品</span>
          <el-select v-model="gasGMap['油品名称']" placeholder="请选择" size="small">
            <el-option v-for="item in OIL_TYPES" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>油罐状态</span>
          <el-select v-model="gasGMap['油罐状态']" placeholder="请选择" size="small">
            <el-option v-for="item in GASG_STATUS" :key="item.key" :label="item.label" :value="item.key">
            </el-option>
          </el-select>
        </div>
        <div class="one-input">
          <span>物理容积</span>
          <el-input v-model="gasGMap['物理容积']" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>停泵库存</span>
          <el-input v-model="gasGMap['停泵库存']" size="small" placeholder="请输入"></el-input>
        </div>
        <div class="one-input">
          <span>有效容积</span>
          <el-input v-model="gasGMap['有效容积']" size="small" placeholder="请输入"></el-input>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddG = false">取 消</el-button>
        <el-button type="primary" @click="saveGasG">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="showDel" size="tiny">
      <template v-if="delType === 'gas'">
        <span>你确定删除该加油站吗？</span><br>
        <span>该加油站相关数据也将被删除</span>
      </template>
      <template v-else>
        <span>你确定删除该油罐吗？</span><br>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDel = false">取 消</el-button>
        <el-button type="primary" @click="delGas">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import ContentTitle from '@/components_bit/ContentTitle'
import MiiBaseTable from '@/components_bit/MiiBaseTable'
import {
  gas,
  car
} from '@/api/oli_api'
import {
  PASS_LIST,
  AXLE_LIST,
  GASG_STATUS,
  OIL_TYPES
} from '@/api/static_data'
import {
  mapCp
} from '@/cllib'

let nullGas = {
  '油站代码': '',
  '区域': '',
  '单位名称': '',
  '加油站名称': '',
  '指定车辆配送限制': ''
}

let nullGasG = {
  '油站代码': '',
  '油品名称': '',
  '罐号': '',
  '油罐状态': '',
  '停泵库存': '',
  '有效容积': '',
  '物理容积': ''
}

export default {
  components: {
    ContentTitle,
    MiiBaseTable
  },
  data () {
    return {
      selectCar: null,
      carList: [],
      xzCarList: [],
      delType: 'gas',
      showAddG: false,
      isNewG: false,
      canSetXz: false,
      isNew: false,
      PASS_LIST,
      AXLE_LIST,
      GASG_STATUS,
      OIL_TYPES,
      pass_key: '',
      axle_key: '',
      selectGas: mapCp(nullGas),
      gasMap: mapCp(nullGas),
      gasGMap: mapCp(nullGasG),
      loadingG: false,
      loading: true,
      showDel: false,
      showAdd: false,
      table_actions: [{
        label: '编辑',
        key: 'edit'
      },
      {
        label: '删除',
        key: 'del'
      }],
      titleAction: [{
        key: 'edit',
        icon: 'icon-bj'
      },
      {
        key: 'del',
        icon: 'icon-105'
      },
      {
        key: 'add',
        icon: 'icon-addfriend'
      }],
      titleAction2: [{
        key: 'add',
        icon: 'icon-addfriend'
      }],
      gasList: [],
      oilGGList: [],
      ths: [{
        key: '罐号',
        label: '罐号'
      },
      {
        key: '油罐状态',
        label: '油罐状态'
      },
      {
        key: '油品名称',
        label: '油品'
      },
      {
        key: '物理容积',
        label: '物理容积'
      },
      {
        key: '停泵库存',
        label: '停泵库存'
      },
      {
        key: '有效容积',
        label: '有效容积'
      }]
    }
  },
  watch: {
    selectGas (value) {
      this.canSetXz = false
      this.loadGasGGList()
      this.pass_key = value['通行证']
      this.axle_key = value['场地限制']
      Vue.nextTick(() => {
        this.canSetXz = true
      })
      this.xzCarList = []
      let carIdList = value['指定车辆配送限制'] ? value['指定车辆配送限制'].split(',') : []
      this.carList.forEach((item) => {
        if (carIdList.indexOf(item['车牌号']) > -1) {
          this.xzCarList.push(item)
        }
      })
    },
    pass_key (value) {
      if (this.canSetXz) {
        this.setXZGas({
          '通行证': value
        })
      }
    },
    axle_key (value) {
      if (this.canSetXz) {
        this.setXZGas({
          '场地限制': value
        })
      }
    },
    selectCar (value) {
      if (value) {
        let inDatas = false
        this.xzCarList.forEach((item) => {
          if (item['车牌号'] === value['车牌号']) {
            inDatas = true
          }
        })
        if (!inDatas) {
          this.xzCarList.push(value)
          this.setGasXz()
        }
      }
    }
  },
  created () {
    this.loadCarList()
  },
  methods: {
    getTextTXZ (str) {
      console.log(str)
      let reStr = '无'
      if (str) {
        let txzList = ['一环通行证', '二环通行证', '三环通行证']
        let strList = str.split(';')
        if (strList.length === 1) {
          reStr = txzList[Number(strList[0].split('=')[1]) - 1]
        } else if (strList.length > 1) {
          reStr = '昆东三环通行证长坡无'
        }
      }
      return reStr
    },
    setGasXz () {
      let carIdStr = ''
      this.xzCarList.forEach((item) => {
        carIdStr += item['车牌号'] + ','
      })
      let parm = {
        action: 'set_gas_car_xz',
        data: {
          'xz_car': carIdStr.slice(0, -1),
          'gas_code': this.selectGas['油站代码']
        }
      }
      gas(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '修改指定配送车辆成功'
          })
          this.gasMap['指定车辆配送限制'] = carIdStr.slice(0, -1)
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '修改配送指定油站失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '修改配送指定油站失败'
        })
      })
    },
    delXzCar (gas) {
      let newDatas = []
      this.xzCarList.forEach((item) => {
        if (item['车牌号'] !== gas['车牌号']) {
          newDatas.push(item)
        }
      })
      this.xzCarList = newDatas
      this.setGasXz()
    },
    loadCarList () {
      let parm = {
        action: 'get_cars',
        data: {
          '配送中心': this.$store.getters.oilArea === 'dl' ? '大配' : '昆配',
          '车辆轴数': ''
        }
      }
      car(parm).then((data) => {
        this.carList = data
        this.loadGasList()
      })
    },
    loadGasList () {
      let parm = {
        action: 'get_gas',
        data: {}
      }
      gas(parm).then((data) => {
        this.gasList = data
        this.loading = false
        if (!this.selectGas['油站代码']) {
          this.selectGas = data.length > 0 ? data[0] : {}
        }
      })
    },
    loadGasGGList () {
      this.loadingG = true
      let parm = {
        action: 'get_gg_gas',
        data: {
          '油站代码': this.selectGas['油站代码']
        }
      }
      gas(parm).then((data) => {
        this.oilGGList = data
        this.loadingG = false
      })
    },
    clickTitleMenu (key) {
      if (key === 'add') {
        this.isNew = true
        this.gasMap = mapCp(nullGas)
        this.showAdd = true
      } else if (key === 'edit') {
        this.isNew = false
        this.gasMap = mapCp(this.selectGas)
        this.showAdd = true
      } else if (key === 'del') {
        this.showDel = true
        this.delType = 'gas'
      }
    },
    clickTitleMenuG (key) {
      if (key === 'add') {
        this.isNewG = true
        this.gasGMap = mapCp(nullGasG)
        this.gasGMap['油站代码'] = this.selectGas['油站代码']
        this.showAddG = true
      }
    },
    clickTdBtn (dataMap) {
      console.log(dataMap)
      this.gasGMap = mapCp(dataMap.data)
      if (dataMap.key === 'del') {
        this.delType = 'gas_gg'
        this.showDel = true
      } else if (dataMap.key === 'edit') {
        this.isNewG = false
        this.showAddG = true
      }
    },
    setXZGas (data) {
      data['油站代码'] = this.selectGas['油站代码']
      let parm = {
        action: 'set_xz_gas',
        data
      }
      gas(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '油站限制已修改'
          })
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '油站限制修改失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '油站限制修改失败'
        })
      })
    },
    saveGas () {
      if (!this.gasMap['油站代码']) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '油站代码必填',
          message: '请输入油站代码'
        })
        return
      }
      let parm = {
        action: this.isNew ? 'add_gas' : 'edit_gas',
        data: this.gasMap
      }
      gas(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: this.isNew ? '油站新增完成' : '油站修改完成'
          })
          this.selectGas = this.gasMap
          this.showAdd = false
          this.loadGasList()
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: this.isNew ? '新增油站失败' : '修改油站失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: this.isNew ? '新增油站失败' : '修改油站失败'
        })
      })
    },
    saveGasG () {
      if (!this.gasGMap['罐号']) {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '罐号必填',
          message: '请输入罐号'
        })
        return
      }
      let parm = {
        action: this.isNewG ? 'add_gg_gas' : 'edit_gg_gas',
        data: this.gasGMap
      }
      gas(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: this.isNewG ? '油罐新增完成' : '油罐修改完成'
          })
          this.showAddG = false
          this.loadGasGGList()
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: this.isNewG ? '新增油罐失败' : '修改油罐失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: this.isNewG ? '新增油罐失败' : '修改油罐失败'
        })
      })
    },
    delGasG () {
      let parm = {
        action: 'del_gg_gas',
        data: {'代号': this.gasGMap['代号']}
      }
      gas(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '油罐删除成功'
          })
          this.loadGasGGList()
          this.showDel = false
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '油罐删除失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '油罐删除失败'
        })
      })
    },
    delGas () {
      if (this.delType !== 'gas') {
        return this.delGasG()
      }
      let parm = {
        action: 'del_gas',
        data: {'油站代码': this.selectGas['油站代码']}
      }
      gas(parm).then((data) => {
        if (data.code === 1) {
          this.$store.dispatch('showNoticeMsg', {
            type: 'success',
            title: '系统提示',
            message: '加油站删除成功'
          })
          this.selectGas = mapCp(nullGas)
          this.loadGasList()
          this.showDel = false
        } else {
          this.$store.dispatch('showNoticeMsg', {
            type: 'error',
            title: '系统提示',
            message: '加油站删除失败'
          })
        }
      }).catch((e) => {
        this.$store.dispatch('showNoticeMsg', {
          type: 'error',
          title: '系统提示',
          message: '加油站删除失败'
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.output-btn {
  color:#fff;
  background-color: @bak-color-2;
  padding: 0.5em 1.5em;
  text-align: center;
  border-radius: 0.3em;
  letter-spacing: 0.1em;
}
.output-content {
  .content-shadow;
  .content-bottom-radius;
  display: flex;
  background-color: #fff;
}
.case-form {
  display: flex;
  flex-wrap: wrap;
}
.one-input {
  display: flex;
  justify-content: space-between;
  width: 46%;
  margin: 1rem 2%;
  span {
    width: 9rem;
    font-size: 0.9rem;
  }
}
.checkbox-label {
  .output-btn {
    margin-left: 3em;
  }
}
.btm-btn {
  margin: 1em 0 0 2em;
}
.gas-info {
  margin-bottom: 1rem;
  .content-shadow;
  .content-bottom-radius;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 0 1rem;
  .info-one {
    min-height: 3rem;
    text-align: center;
    width: 33%;
    display: flex;
    align-items: center;
    color: #666;
    font-size: 1.1rem;
    span {
      color: #999;
      margin-right: 1rem;
    }
  }
}
.car-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  span {
    font-size: 0.9rem;
    padding:0.1rem 0.7rem;
    border-radius: 0.2rem;
    width: auto !important;
    background-color: #ddd;
    margin: 0 0.7rem 0.5rem 0;
  }
  .icon-105 {
    margin-left: 0.5rem;
    color: red;
  }
}
.m-line {
  width: 2px;
  height: 15em;
  background-color: #ccc;
  margin: 1.5em 2.2em 0 0;
}
.output-content-1 {
  flex: 1;
  margin: 1em 2.5em 7em;
  display: flex;

}
.checkbox-content {
  display: flex;
  flex-direction: column;
  span {
    line-height: 1;
    font-size: 1.13em;
    padding-bottom: 0.5em;
    color: @bak-color-2;
  }
}
.checkbox-one {
  display: flex;
  align-items: center;
  height: 3.4em;
  font-size: 1em;
  color:@bak-color-1;
  img {
    padding-right: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// gas.vue?54bb8e07